import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor() { }

  // Method to export an HTML table to Excel
  exportTableToExcel(table: any, filename: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);

    // Set each column to be twice the default size (128 pixels)
    const columnCount = worksheet['!ref'] ? XLSX.utils.decode_range(worksheet['!ref']).e.c + 1 : 0;
    const columnWidths = Array(columnCount).fill({ wpx: 128 }); // Set each column width to 128 pixels

    // Set the column widths in the worksheet
    worksheet['!cols'] = columnWidths;
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, filename);
  }

  // Method to export an array of objects to Excel
  exportToExcel(data: any[], fileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    // Set each column to be twice the default size (128 pixels)
    const columnCount = worksheet['!ref'] ? XLSX.utils.decode_range(worksheet['!ref']).e.c + 1 : 0;
    const columnWidths = Array(columnCount).fill({ wpx: 128 }); // Set each column width to 128 pixels

    // Set the column widths in the worksheet
    worksheet['!cols'] = columnWidths;

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, fileName);
  }

  // Helper method to save the Excel file
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(data, fileName + '.xlsx');
  }
}
